import { StripeIntentFields, StripePaymentIntentService } from "booking_app/services/stripe-payment-intent.service";
import { AppSettings } from "booking_app/values/app-settings";

export class StripeIntentPaymentFormController {
  static $inject = [
    "$scope",
    "StripePaymentIntentService",
    "AppSettings",
  ];

  // binding
  bookingDetails: any;
  checkOutForm: any;

  constructor(
    private $scope: any,
    public stripePaymentIntentService: StripePaymentIntentService,
    public appSettings: AppSettings,
  ) { }

  $onInit() {
    this.stripePaymentIntentService.mountStripeIntentElements();
    this.stripePaymentIntentService.setupOnChangeListeners(this.$scope);
  }

  showErrorMessage(field: StripeIntentFields): boolean {
    return (
      this.stripePaymentIntentService.errorFlags[field] ||
      (this.checkOutForm.submitted && !this.stripePaymentIntentService.stripeIntentForm[field])
    );
  }
}
